import { createContext, useContext } from 'react';

type LayoutChromeContextValue = {
  embedded: boolean;
};

export const LayoutChromeContext = createContext<LayoutChromeContextValue>({ embedded: false });

export function useLayoutChrome() {
  return useContext(LayoutChromeContext);
}
